module.exports = __webpack_public_path__ + "img/shuixian3.7d0402d8.png";